<template>
  <default-textual-section v-if="$store.state.displayType === 'textual'" :menu="menu" :section="section"
                           :menu-item-component="menuItemComponent"
                           class="menu--section-mothers_day" menu-item-tag-location="before-title">
  </default-textual-section>
  <default-visual-section v-else :menu="menu" :section="section"
                          :menu-item-component="menuItemComponent"
                          class="menu--section-mothers_day" menu-item-tag-location="before-title">
  </default-visual-section>
</template>

<script lang="ts">
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 0.1.0
 * @copyright  Copyright (C) 2025-2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2025-4-09 (1.0.0) (jhoward)
 *    - Copy from Easter_defaultSection.vue component to MothersDay_defaultSection.vue component.
 * @changelog
 *
 * 2026-07-20 (0.1.0) (jhoward)
 *   - Update App\Library\Js\Components\Menu\Section\MothersDay_defaultSection.vue to use Mother's Day 2026 background, adjust padding, and improve responsive layout.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";

export default defineComponent({
  components: {
    DefaultVisualSection, DefaultTextualSection,
  },
  name: "MothersDay_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menuVersion: {
      type: String,
      default: ''
    },
    sectionModifier: {
      type: String,
      default: ''
    },
    menu: {
      type: Object as PropType<Menu | null>,
      required: true
    }
  },
  mounted() {
    this.section.ms_title = this.sectionTitle();
    this.section.ms_subtitle = this.sectionSubtitle();
  },
  data: function () {
    return {};
  },
  methods: {
    sectionTitle(): string {
      if ('mother\'s day menu' === this.section.ms_title.toLowerCase()) {
        return 'MOTHER\'S DAY DINING';
      }

      return this.section.ms_title.toUpperCase();
    },
    sectionSubtitle(): string {
      return (this.menu?.page?.page_h1 || '').toUpperCase();
    },
  }
})
</script>

<style>
.textual_menu--container > h1,
.page-link-group-hash {
  display: none;
}
</style>

<style scoped>
.menu--section-mothers_day {
  position: relative;
  font-size: 1.4em;
  color: #231f20;
  text-align: center;
  padding: 23rem 9rem 5rem 9rem !important;
}

/*WV Requirements*/
.menu--section-mothers_day:deep(.viewport) {
  margin: initial;
}

.menu--section-mothers_day::before {
  content: '';
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('/library/images/menu/background-mothers-day-2026.jpg');
  background-size: cover;
  background-position: top center;

  /*WV Requirements*/
  height: auto;
  opacity: 1;
  visibility: visible;
}

@media (max-width: 700px) {
  .menu--section-mothers_day {
    padding-top: 50vw !important;
    background-color: #f9faf4;
  }

  .menu--section-mothers_day::before {
    background-size: 120% auto;
    height: 40vw;
  }
}

.textual_menu--section.menu--section-mothers_day {
  display: flex;
  flex-direction: column;
  padding-bottom: 8rem;
  /*padding-left: 3rem;
  padding-right: 3rem;*/
}

/*.menu--section-mothers_day::before {
  content: '';
  position: absolute;
  z-index: -2;
  top: 11.15rem;
  right: 3.85rem;
  bottom: 3.85rem;
  left: 3.85rem;
  border: 0.25rem solid #FFF;
}

.textual_menu--section.menu--section-mothers_day::before {
  top: 11.35rem;
  right: 3.65rem;
  bottom: 3.45rem;
  left: 3.65rem;
}*/

@media (max-width: 800px) {
  .textual_menu--section.menu--section-mothers_day {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  /*.textual_menu--section.menu--section-mothers_day::before {
    right: 0.35rem;
    bottom: 0.35rem;
    left: 0.35rem;
  }

  .textual_menu--section.menu--section-mothers_day::after {
    left: 1rem;
    right: 1rem;
    bottom: 1rem;
  }*/

  .textual_menu--section.menu--section-mothers_day:deep(.menu--tag) {
    position: relative;
    left: initial;
    top: initial;
    float: right;
  }

  .textual_menu--section.menu--section-mothers_day:deep(.menu--item_description br) {
    display: none;
  }
}

/*.menu--section-mothers_day::after {
  content: '';
  position: absolute;
  z-index: -2;
  top: 12rem;
  left: 3em;
  right: 3em;
  bottom: 3em;
  background-color: #FFF;
}*/

.menu--section-mothers_day:deep(.menu--highlight) {
  /*color: #ed2030;*/
  font-weight: bold;
}

.menu--section-mothers_day:deep(.menu--item_description h4) {
  font-size: 1.4em;
  color: #000;
}

.menu--section-mothers_day:deep(.menu--item_description strong) {
  font-size: 1.2em;
}

.menu--section-mothers_day:deep(.menu--item_description p) {
  margin-top: 0;
  margin-bottom: 0;
}

.menu--section-mothers_day:deep(.menu--item_title-mothers_day) {
  font-size: 1.2em;
}

h2 {
  padding-left: 0;
}

h2 img {
  width: 83%;
}

.menu--section-mothers_day:deep(.menu--section_title) {
  display: none;
  /*font-family: itc-avant-garde-gothic-pro, sans-serif;
  letter-spacing: 0.1em;
  font-weight: 300;
  font-size: 2em;
  transform: scaleY(0.85);
  border-top: 0.4rem dotted #ffc523;
  padding: 0.7em 0.5em 0;
  margin-top: 0.4em;
  color: #9e4298;
  max-width: 500px;*/
}

.menu--section-mothers_day:deep(.menu--section_subtitle) {
  text-align: center;
  font-family: trajan-pro-3, serif;
  font-size: 2.55em;
  width: 80%;
  margin: 0.3em auto 0;
  line-height: 1em;
  order: -1;
}

@media (max-width: 1024px) {
  /*.textual_menu--section.menu--section-mothers_day:deep(.menu--section_title) {
    letter-spacing: initial;
  }*/

  .textual_menu--section.menu--section-mothers_day:deep(.menu--section_subtitle) {
    font-size: 2em;
    letter-spacing: initial;
    margin-left: 0;
    margin-right: 0;
    width: initial;
  }
}

@media (max-width: 800px) {
  .textual_menu--section.menu--section-mothers_day:deep(.menu--section_subtitle) {
    font-size: 1.5em;
    word-break: initial;
  }
}

.menu--section-mothers_day:deep(.visual_menu--page_section-top),
.menu--section-mothers_day:deep(.menu--page_content.menu--page_content-top.page-link-group-copy) {
  border-top: 0.2rem solid #ee2030;
  border-bottom: 0.2rem solid #ee2030;
  max-width: 500px;
  margin: 1.2em auto 0;
  padding-bottom: 1em;
  padding-top: 0.8em;
}

.menu--section-mothers_day:deep(.visual_menu--page_section-top p) {
  margin-top: 0;
  margin-bottom: 0;
}

.menu--section-mothers_day:deep(.visual_menu--page_section-top p:first-child),
.menu--section-mothers_day:deep(.menu--page_content-top p:first-child) {
  font-weight: bold;
}

.menu--section-mothers_day:deep(.visual_menu--page_section-bottom) {
  padding-top: 0;
}

.menu--section-mothers_day:deep(.visual_menu--page_section-bottom .visual_menu--page_section-bottom),
.menu--section-mothers_day:deep(.menu--page_content.menu--page_content-bottom.page-link-group-copy) {
  padding-top: 2rem;
  margin-top: 2rem;
  position: relative;
}

.menu--section-mothers_day:deep(.visual_menu--page_section-bottom .visual_menu--page_section-bottom::before),
.menu--section-mothers_day:deep(.menu--page_content.menu--page_content-bottom.page-link-group-copy::before) {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background: #ee2030;
  width: 100%;
  max-width: 300px;
  height: 0.2rem;
}

.menu--section-mothers_day:deep(.menu--page_section-bottom .menu--page_section-bottom) {
  padding-top: 1.25em;
  position: relative;
}

/*.menu--section:deep(.menu--page_section-bottom .menu--page_section-bottom::before) {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 60%;
  height: 0.125em;
  transform: translateX(-50%);
  background-color: #ed2030;
}*/
/*
.menu--section-mothers_day:deep(.menu--item_title) {
  color: #9e4298;
}*/

.menu--section-mothers_day:deep(.menu--item_subgroup .menu--item) {
  display: block;
}

.menu--section-mothers_day:deep(.menu--tag) {
  top: 0;
  left: 15%;
  right: initial;
  width: 1.5em;
  height: 1.5em;
}

.menu--section-mothers_day:deep(.visual_menu--page_section-bottom + .viewport),
.menu--section-mothers_day:deep(.viewport + .viewport) {
  display: none;
}
</style>